import { render, staticRenderFns } from "./Pricing_Github.vue?vue&type=template&id=1924141d&scoped=true"
import script from "./Pricing_Github.vue?vue&type=script&lang=js"
export * from "./Pricing_Github.vue?vue&type=script&lang=js"
import style0 from "./Pricing_Github.vue?vue&type=style&index=0&id=1924141d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924141d",
  null
  
)

export default component.exports